module.exports = __webpack_public_path__ + "img/02-illu-kafu2021.6e927f74.jpg";